import PIEText from '@src/shared/components/PIEText';
import React, { useMemo } from 'react';
import styles from './UserInformationContent.module.scss';
import { useKeycloakUserState } from '@src/shared/context/keycloak-user';
import { IUser } from '@src/shared/context/current-user';
import { IconChevronRight, IconLogOut, IconTutorial } from '@justeattakeaway/pie-icons-react';
import { languages } from '@src/i18n';
import authEvents from '@src/shared/services/auth-events';
import { useTranslation } from 'react-i18next';
import { useOnboardingStore } from '@src/shared/store/onboarding/onboarding-store';
import { isDashboardAllowed } from '@src/shared/utils';
import { useHistory } from 'react-router-dom';
import { useTutorialActions } from '@src/shared/context/tutorial';
import { TUTORIAL_OCF } from '@src/shared/components/Tutorial/TutorialsContainer';
import useOCFStatus from '@src/shared/hooks/use-ocf-status';

interface componentProps {
  onLanguageMenu?: () => void;
  onTutorialReview?: () => void;
}
const UserInformationContent = ({ onLanguageMenu, onTutorialReview }: componentProps) => {
  const { restaurant } = useKeycloakUserState();
  const { t, i18n } = useTranslation();
  const { setOnboardingActive, setActiveStep } = useOnboardingStore();
  const { isOCFEnabled } = useOCFStatus();
  const { startTutorial } = useTutorialActions();
  const history = useHistory();

  const userData = useMemo<IUser | null>(() => {
    return restaurant;
  }, [restaurant]);
  const onLogout = () => {
    authEvents.emitLogoutKeycloakUser(true);
  };

  return (
    <>
      <div className={styles.UserPanelRestaurantInfo}>
        <PIEText
          size="var(--xds-font-size-16)"
          fontWeight="var(--xds-font-weight-bold)"
          text={userData?.name}
        />
        <PIEText
          size="var(--xds-font-size-14)"
          fontWeight="var(--xds-font-weight-regular)"
          text={` #${userData?.id}`}
        />
      </div>
      <div className={styles.UserpanelDrawerSubSection}>
        {isDashboardAllowed(restaurant?.country as string) === true ? (
          <div
            className={styles.ReviewTutorialLogoutBar}
            onClick={() => {
              setActiveStep(1);
              setOnboardingActive(true);
              onTutorialReview?.();
              history.push('/deliveries');
            }}
          >
            <IconTutorial size={'m'} />
            <PIEText
              size="var(--xds-font-size-16)"
              fontWeight="var(--xds-font-weight-regular)"
              text={t('onboarding_dashboard.TUTORIAL_REVIEW')}
            />
          </div>
        ) : null}

        {isOCFEnabled ? (
          <div
            className={styles.ReviewTutorialLogoutBar}
            onClick={() => {
              onTutorialReview?.();
              history.push('/couriers');
              window.requestAnimationFrame(() => {
                startTutorial(TUTORIAL_OCF);
              });
            }}
          >
            <IconTutorial size={'m'} />
            <PIEText
              size="var(--xds-font-size-16)"
              fontWeight="var(--xds-font-weight-regular)"
              text={t('ocf_screens.TUTORIAL_REVIEW')}
            />
          </div>
        ) : null}

        <div className={styles.UserPanelLanguageBar} onClick={onLanguageMenu}>
          <img className="langIcon" src={languages[i18n.language].img} alt="Toggle menu" />
          <PIEText
            size="var(--xds-font-size-16)"
            fontWeight="var(--xds-font-weight-regular)"
            text={languages[i18n.language].title}
          />

          <IconChevronRight className={styles.UserPanelLanguageBarChevronIcon} size="m" />
        </div>
        <div className={styles.UserPanelLogoutBar} onClick={() => onLogout()}>
          <IconLogOut size={'m'} />
          <PIEText
            size="var(--xds-font-size-16)"
            fontWeight="var(--xds-font-weight-regular)"
            text={t('navigation.logout')}
          />
          <PIEText
            customStyle={{ flex: 1 }}
            size="var(--xds-font-size-11)"
            fontWeight="var(--xds-font-weight-bold)"
            text={`v.${process.env.MCP_VERSION as string}`}
            align="right"
          />
        </div>
      </div>
    </>
  );
};

export default UserInformationContent;
